import recipe from './recipe';

export default {
  recipe,
};
